import utilsApi from '../../assets/js/utils';

import config from '../config/index';

export default utilsApi.creatApi({
    getRiotShopAccounts: ['get', config.riotShopAccountUrl + '/valorant/userAccountIno'],
    // 绑定账号
    bindAccount: ['post', config.baseUrl + '/valorantTracker/bind'],
    bindRiotAccount: ['post', config.baseUrl + '/valorantTracker/riot/bind'],
    getRiotStats: ['post', config.baseUrl + '/valorantTracker/riot/query'],
    getRiotClientPlan: ['post', config.baseUrl + '/valorantTracker/riot/clientPlan'],
    getRiotMatchDetails: ['post', config.baseUrl + '/valorantTracker/riot/matchDetails'],
    reportRiotStatsEvent: ['post', config.baseUrl + '/valorantTracker/riot/stats/event'],
    // 查询Riot授权会话状态（只读Redis，不触发第三方请求）
    getAuthorizationStatus: ['get', config.baseUrl + '/valorantTracker/authorization/status'],
    // 获取绑定用户信息
    getBindInfo: ['post', config.baseUrl + '/valorantTracker/getUserBindInfo'],
    // 查询战绩信息
    getTrackeInfo: ['get', config.baseUrl + '/valorantTracker/getTrackerInfo'],
    // 查询列表数据 
    matches: ['get', config.baseUrl + '/valorantTracker/matches'],
    //战绩详情
    matcheDetails: ['get', config.baseUrl + '/valorantTracker/matcheDetails'],
    // 快结帐号列表
    getQuickAccounts: ['get', '//router.gamersky.com/@' + '/valorantTracker/getDefaultValorantUserName'],
    // 解除绑定账号
    unBindAccount: ['post', config.baseUrl + '/valorantTracker/unbind'],
    // 获取绑定账号列表
    getBindAccountList: ['get', config.baseUrl + '/valorantTracker/getBindAccountList'],
    // 批量绑定完成后切换默认账号的防迟到令牌
    prepareActiveAccountOperation: ['post', config.baseUrl + '/valorantTracker/prepareActiveAccountOperation'],
    // 切换活动账号
    changeActiveAccount: ['post', config.baseUrl + '/valorantTracker/changeActiveAccount'],

    // 上报统计，2024-5-31下线此统计功能
    reportStatus: ['get', "https://router3.gamersky.com/@/importantLog/valorant_stats/record"],
    

});
